import React from 'react';

const Spinner = ({ size = 'default', centered, inline, title }) => (
    <span className={'spinner' + (centered ? ' centered' : '' + (inline ? ' inline' : ''))} data-size={size} data-title={title}>
        <i className="ion ion-load-c" />
    </span>
);

export default Spinner;
